import { env } from "@/env";

export const TestingModeOnly = ({ children }) => {
  if (env.NEXT_PUBLIC_TESTING_MODE !== "true") return null;

  return <>{children}</>;
};

export default TestingModeOnly;
